import { render } from "./ModalConfirmSelectVoucher.vue?vue&type=template&id=60791e7c"
import script from "./ModalConfirmSelectVoucher.vue?vue&type=script&lang=js"
export * from "./ModalConfirmSelectVoucher.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__